import React, { useCallback } from "react";

import { Card } from "../../../components/Card";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { Flex, Stack } from "@chakra-ui/react";
import { Input } from "../../../components/Form/Input";
import { api } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { BackButton } from "../../../components/atoms/Button/BackButton";
import { SubmitButton } from "../../../components/atoms/Button/SubmitButton";
import { useToast } from "../../../hooks/toast";

const createCategoryFormSchema = yup.object().shape({
  name: yup
    .string()
    .required("Nome obrigatório")
    .min(3, "O nome deve conter no mínimo 3 caracteres"),
  company_id: yup.mixed().nullable(),
});

export function CreateCategory() {
  const navigate = useNavigate();
  const toast = useToast();
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(createCategoryFormSchema),
  });
  const handleCreateCategory: SubmitHandler<FieldValues> = useCallback(
    async (formValue) => {
      try {
        await api.post("/categories", {
          name: formValue.name,
        });

        navigate("/categorias");
        toast({
          title: "Categoria cadastrada com sucesso!",
          status: "success",
        });
      } catch (err) {
        toast({
          title: "Não foi possível cadastrar a categoria",
          status: "error",
        });
      }
    },
    [navigate, toast]
  );

  const { errors } = formState;

  return (
    <>
      <Card
        border="#216ca5"
        title="Cadastrar Categoria"
        header={<BackButton onClick={() => navigate(-1)} />}
        body={
          <Flex
            as="form"
            flexDir="column"
            w="100%"
            onSubmit={handleSubmit(handleCreateCategory)}
            id="add-form"
          >
            <Stack spacing="4">
              <Input
                type="text"
                label="Nome"
                isRequired={true}
                error={errors.name}
                {...register("name")}
              />
            </Stack>
          </Flex>
        }
        footer={<SubmitButton formState={formState} />}
      />
    </>
  );
}
